module.exports = __webpack_public_path__ + "static/media/ideal-web.52a9b4f2.svg";